import { h, Fragment, } from "@stencil/core";
import { ICON_NAMESPACE } from "../../icons/namespace";
import { variantClasses } from "./utils/cellClasses";
import { variantMatches } from "./utils/variantMatches";
export const TableHeader = ({ headless = false, sort = [], sticky = false, columnGroups, clickSort, headerHeight, }) => {
    if (headless)
        return null;
    const [sortKey, order] = sort;
    const grouped = columnGroups.some(([g]) => g != null);
    const renderCellHeader = ([name, cell], classes = {}, props = {}) => {
        const { title, sortable, variant } = cell;
        if (variantMatches(variant, 'full-width'))
            return;
        if (sortable) {
            return (h("c2-button", { role: 'columnheader', "aria-sort": sortKey === name ? order : 'none', variant: 'minimal', onClick: () => clickSort.emit(name), class: { ...classes, ...variantClasses(cell) }, ...props }, title ?? '', h("c2-icon", { size: 20, icon: [
                    ICON_NAMESPACE,
                    sortKey === name ? 'sorted' : 'sort',
                ], slot: 'after', angle: order === 'ascending' ? 0 : -180 })));
        }
        return (h("div", { role: 'columnheader', "aria-sort": sortKey === name ? order : 'none', class: { ...classes, ...variantClasses(cell) }, ...props }, title ?? ''));
    };
    return (h(Fragment, null, h("div", { role: 'row', class: { sticky } }, columnGroups.map(([group, children]) => {
        if (!group) {
            return children.map((cell) => renderCellHeader(cell));
        }
        return (h("div", { role: 'columnheader', style: { gridColumn: `span ${children.length}` } }, group ?? ''));
    })), grouped && (h("div", { role: 'row', class: { sticky, subheader: true } }, columnGroups.map(([group, children], group_index, groups) => {
        if (!group) {
            return (h("div", { role: 'columnheader', class: {
                    group_first: group_index !== 0,
                    group_last: group_index !==
                        groups.length - 1,
                }, style: {
                    gridColumn: `span ${children.length}`,
                    top: headerHeight
                        ? `calc(var(--sticky-top, 0px) + ${headerHeight}px)`
                        : undefined,
                } }));
        }
        return children.map((cell, cell_index, cells) => renderCellHeader(cell, {
            group_first: group_index !== 0 &&
                cell_index === 0,
            group_last: group_index !== groups.length - 1 &&
                cell_index === cells.length - 1,
        }, {
            style: headerHeight
                ? {
                    top: `calc(var(--sticky-top, 0px) + ${headerHeight}px)`,
                }
                : undefined,
        }));
    })))));
};
//# sourceMappingURL=TableHeader.js.map
